const customFieldIcons = [
  {
    type: 'dropdown',
    icon: 'circle-chevron-down-light',
  },
  {
    type: 'status',
    icon: 'exclamation-triangle',
  },
  {
    type: 'number-integer',
    icon: 'hashtag-light',
  },
  {
    type: 'text-short',
    icon: 'text',
  },
  {
    type: 'date',
    icon: 'calendar-light',
  },
  {
    type: 'url',
    icon: 'link-light',
  },
  {
    type: 'checkbox',
    icon: 'check-square-light',
  },
];

export default function findCustomFieldIconByType(customFieldType) {
  const customField = customFieldIcons.find(
    (customFieldIcon) => customFieldIcon.type === customFieldType,
  );
  return customField ? customField.icon : 'text';
}
